export const SET_FOOTER_DATA = 'SET_FOOTER_DATA';

export const setFooterData = (footerData) => {
  return {
    type: SET_FOOTER_DATA,
    payload: footerData,
  };
};